import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { boxSizingKeys, boxSizingMixin, fullHeightKeys, fullHeightMixin, fullWidthKeys, fullWidthMixin } from '../mixins/layout';
import { containerKeys, containerMixin } from '../mixins/container';
import { withOmitProps } from '../helpers/elements';
import { backgroundColorKeys, backgroundColorMixin } from '../mixins/color';
var Container = styled.div.withConfig(withOmitProps([].concat(boxSizingKeys, fullWidthKeys, fullHeightKeys, containerKeys, backgroundColorKeys)))(_templateObject(), boxSizingMixin, fullWidthMixin, fullHeightMixin, containerMixin, backgroundColorMixin);
export default Container;